import { Link, styled, Typography } from "@material-ui/core";

export const TTHTKnowledgeBankOverviewContentWrapper = styled("div")(
  ({ theme }) => ({
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap",
    display: "flex",
    maxWidth: "1200px",

    "& > div": {
      width: "33%",
      padding: theme.spacing(2),
    },

    [`${theme.breakpoints.down("sm")}`]: {
      "& > div": {
        width: "50%",
      },
    },

    [`${theme.breakpoints.down("xs")}`]: {
      "& > div": {
        width: "100%",
      },
    },
  })
);

export const TTHTKnowledgeBankOverviewItemDescription = styled(Typography)(
  ({ theme }) => ({
    marginBottom: theme.spacing(3),
    fontSize: theme.typography.body2.fontSize,
    textAlign: "center",
  })
);

export const TTHTKnowledgeBankOverviewItemTitle = styled(Typography)(
  ({ theme }) => ({
    fontSize: theme.typography.body1.fontSize,
    textAlign: "center",
    fontWeight: theme.typography.fontWeightBold,
  })
);

export const TTHTKnowledgeBankOverviewItemImage = styled("div")(
  ({ theme }) => ({
    border: `2px solid ${theme.palette.grey[200]}`,
    padding: theme.spacing(1),
    margin: theme.spacing(2),
  })
);



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitHowTo/components/Sections/KnowledgeBankOverview/TTHTKnowledgeBankSection.styled.js